import React, { useEffect, useRef } from 'react';

interface AudioPlayerProps {
  audioUrl: string | null;
  timestamp: string | null;
  textPreview?: string | null;
}

/**
 * Component for playing audio received from AppSync subscription.
 * Now uses S3 URLs directly instead of base64 encoded data.
 */
const AudioPlayer: React.FC<AudioPlayerProps> = ({ audioUrl, timestamp, textPreview }) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    if (audioUrl && audioRef.current) {
      try {
        // Set the audio source directly from the S3 URL
        audioRef.current.src = audioUrl;

        // Play audio (safe now that autoplay is unlocked)
        audioRef.current.play().catch(err => {
          console.warn('Playback error (should not happen if unlocked):', err);
        });
      } catch (err) {
        console.error('Error playing audio:', err);
      }
    }
  }, [audioUrl, timestamp]);

  return (
    <div className="audio-player">
      {audioUrl ? (
        <>
          <audio ref={audioRef} controls />
          <div className="audio-info">
            <p>Received at: {timestamp ? new Date(timestamp).toLocaleTimeString() : 'Unknown'}</p>
            {textPreview && <p className="text-preview">"{textPreview}"</p>}
          </div>
        </>
      ) : (
        <div className="audio-placeholder">
          <p>Waiting for audio from KOReader</p>
          <p className="audio-placeholder-hint">(You can also select one from the Audio History to play it)</p>
        </div>
      )}
    </div>
  );
};

export default AudioPlayer;
